/* era-posthog.js - Shopify funnel events for PostHog (Erawell).
   Base posthog.init() runs in theme.liquid <head>. This adds named funnel steps. */
(function(){
  function waitPH(cb,tries){
    tries=tries||0;
    if(window.posthog&&window.posthog.capture){ try{cb()}catch(e){} return; }
    if(tries>40) return;
    setTimeout(function(){waitPH(cb,tries+1)},150);
  }
  function meta(){ return (window.ShopifyAnalytics&&window.ShopifyAnalytics.meta)||window.meta||{}; }
  function product(){ return meta().product||null; }
  function pageType(){ var p=meta().page||{}; return p.pageType||''; }
  function firstVariant(){ var pr=product(); return (pr&&pr.variants&&pr.variants[0])||{}; }
  waitPH(function(){
    var pt=pageType();
    if(pt==='product'){
      var pr=product()||{}, v=firstVariant();
      posthog.capture('product_viewed',{
        product_id:pr.id, product_name:v.name||document.title,
        product_type:pr.type, vendor:pr.vendor,
        price:(typeof v.price==='number')?v.price/100:null,
        sku:v.sku||null, path:location.pathname
      });
    }
    if(pt==='cart'){ posthog.capture('cart_viewed',{path:location.pathname}); }
    document.addEventListener('submit',function(ev){
      try{ var f=ev.target; if(f&&f.getAttribute&&/\/cart\/add/.test(f.getAttribute('action')||'')){
        var v=firstVariant();
        posthog.capture('product_added_to_cart',{method:'form',product_name:v.name||document.title,price:(typeof v.price==='number')?v.price/100:null,path:location.pathname});
      }}catch(_){}
    },true);
    document.addEventListener('click',function(ev){
      try{
        var atc=ev.target.closest&&ev.target.closest('button[name="add"], .product-form__submit, [data-add-to-cart], [class*="add-to-cart"] button');
        if(atc){ var v=firstVariant(); posthog.capture('add_to_cart_click',{product_name:v.name||document.title,price:(typeof v.price==='number')?v.price/100:null,path:location.pathname}); }
        var co=ev.target.closest&&ev.target.closest('[name="checkout"], a[href*="/checkout"], button[href*="/checkout"], .cart__checkout-button');
        if(co){ posthog.capture('reached_checkout',{path:location.pathname}); }
      }catch(_){}
    },true);
  });
})();
